function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 35 35"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20 18l-3.75 2.598v-5.196L20 18z",
  fill: "#354147"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-.164 5.836h35.329V29.85H-.165V5.837zm2.329 2.329v19.357h30.67V8.165H2.166z",
  fill: "#354147"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.6 16.4H7.4v3.2h3.2v-3.2zM5 14v8h8v-8H5zM27.6 16.4h-3.2v3.2h3.2v-3.2zM22 14v8h8v-8h-8z",
  fill: "#354147"
})));